export const doGetFirebaseToken = async ({
  firebase,
  setFirebaseMessagingToken,
}) => {
  const messaging = firebase.firebaseMessaging

  if (messaging) {
    const vapidKey = messaging.vapidKey
    const confirmPermission = await Notification.requestPermission()
    if (confirmPermission === 'granted') {
      let messageResponse = null
      try {
        messageResponse = await messaging.getToken({ vapidKey })
      } catch (error) {
        console.debug('Problem in Firebase Get Token')
      }

      try {
        await messaging.deleteToken(messageResponse)
      } catch (error) {
        console.debug('Problem in Firebase Delete Token')
      }

      try {
        const firebaseMessagingToken = await messaging.getToken({ vapidKey })
        setFirebaseMessagingToken(firebaseMessagingToken)
        this &&
          this.setState &&
          this.setState({
            firebaseMessagingToken,
          })
      } catch (error) {
        console.debug('Problem in Firebase Get Token')
      }
    }
  }
}

export const doSubscribeToFirebaseMessaging = ({
  firebaseMessagingToken,
}) => async () => {
  const topic = process.env.REACT_APP_FIREBASE_MESSAGING_TOPIC

  try {
    await fetch(
      `https://iid.googleapis.com/iid/v1/${firebaseMessagingToken}/rel/topics/${topic}`,
      {
        method: 'POST',
        headers: new Headers({
          Authorization: `key=${process.env.REACT_APP_FIREBASE_SERVER_KEY}`,
          'Content-Type': 'application/json',
          'Content-Length': 0,
        }),
      },
    )
  } catch (e) {
    console.debug('Problem in Firebase Subscribe')
  }
}

export const doSubscribeToFirebaseGuest = async ({
  firebase,
  doSubscribeToFirebaseMessaging,
  setFirebaseMessagingToken,
}) => {
  const messaging = firebase.firebaseMessaging
  if (messaging) {
    const confirmPermission = await Notification.requestPermission()
    if (confirmPermission === 'granted') {
      const messageResponse = await messaging.getToken()
      try {
        await messaging.deleteToken(messageResponse)
      } catch (error) {}
      try {
        const firebaseMessagingToken = await messaging.getToken()

        console.debug(firebase)
        sessionStorage.setItem('firebaseMessagingToken', firebaseMessagingToken)
        setFirebaseMessagingToken(firebaseMessagingToken)
        //vapidKey: "BDOU99-h67HcA6JeFXHbSNMu7e2yNNu3RzoMj8TM4W88jITfq7ZmPvIM1Iv-4_l2LxQcYwhqby2xGpWwzjfAnG4"
        // messaging.onMessageCallback(payload => {
        //   console.debug('payloadOnMessage', payload)
        //   sessionStorage.setItem('payloadOnMessage', payload)
        //   sessionStorage.setItem('triggerShutDown', true)
        // })
        // messaging.onMessage(payload => {
        //   console.debug('payloadOnMessage', payload)
        //   sessionStorage.setItem('payloadOnMessage', payload)
        //   sessionStorage.setItem('triggerShutDown', true)
        // })
        // messaging.onBackgroundMessage(payload => {
        //   console.debug('payloadOnBackgroundMessage', payload)
        //   sessionStorage.setItem('payloadOnBackgroundMessage', payload)
        //   sessionStorage.setItem('triggerShutDown', true)
        // })
        this.setState({
          firebaseMessagingToken,
        })
        doSubscribeToFirebaseMessaging({ firebaseMessagingToken })
      } catch (error) {
        console.debug(error)
      }
    }
  }
}
